export interface ProductionCostHeaderStepsProps {
  step: ProductionCostHeaderStepOption;
}

export enum ProductionCostHeaderStepOption {
  SelectSchedules = 1,
  DataEntry = 2,
  Summary = 3
}
